/**
 * Size guide dialog: opening, closing and the controls inside it.
 *
 * snippets/variant-main-picker.liquid renders the dialog, but a {% javascript %}
 * block in a snippet is compiled into snippet-scripts.js, which Shopify only
 * serves on the pages whose sections render that snippet -- product pages. The
 * dialog is also moved into the quick add sheet on collection pages, where that
 * bundle never loads, so the Size and Inseam tabs and the CM/IN switch were
 * inert there. This file ships from layout/theme.liquid on every page, so the
 * guide behaves the same wherever it is opened.
 */
(function () {
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var opener = target.closest('[data-kalea-size-guide-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-kalea-size-guide-open'));
      if (dialog && !dialog.open) {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }

    var closer = target.closest('[data-kalea-size-guide-close]');
    if (closer) {
      var open = closer.closest('dialog');
      if (open && open.open) open.close();
      return;
    }

    // A click that lands on the dialog itself is a click on the backdrop,
    // since the panel inside covers everything else.
    if (target.matches('dialog.kalea-size-guide-dialog')) {
      target.close();
      return;
    }

    var primaryTab = target.closest('.kalea-guide .kg-ptab');
    if (primaryTab) {
      var guide = primaryTab.closest('.kalea-guide');
      var view = primaryTab.getAttribute('data-view');

      guide.setAttribute('data-view', view);
      guide.querySelectorAll('.kg-ptab').forEach(function (tab) {
        var isActive = tab === primaryTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      guide.querySelectorAll('.kg-view').forEach(function (section) {
        section.classList.toggle('is-active', section.classList.contains('kg-view--' + view));
      });

      var title = guide.querySelector('.kg-title');
      if (title) title.textContent = view === 'inseam' ? 'Inseam Guide' : 'Size Guide';
      return;
    }

    var subTab = target.closest('.kalea-guide .kg-stab');
    if (subTab) {
      var subGuide = subTab.closest('.kalea-guide');
      var panelName = subTab.getAttribute('data-panel');

      subGuide.querySelectorAll('.kg-stab').forEach(function (tab) {
        var isActive = tab === subTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      subGuide.querySelectorAll('.kg-panel').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-panel') === panelName);
      });
      return;
    }

    var unitButton = target.closest('.kalea-guide .kg-unit');
    if (unitButton) {
      var unitGuide = unitButton.closest('.kalea-guide');
      var unit = unitButton.getAttribute('data-unit');

      unitGuide.setAttribute('data-unit', unit);
      unitGuide.querySelectorAll('.kg-unit').forEach(function (button) {
        var isActive = button.getAttribute('data-unit') === unit;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      unitGuide.querySelectorAll('[data-cm][data-in]').forEach(function (cell) {
        cell.textContent = cell.getAttribute(unit === 'in' ? 'data-in' : 'data-cm');
      });
    }
  });
})();
